import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { elementColors, fontColors } from '@sphereon/ui-components.core';
import StepMarker from '../../assets/markers/StepMarker';
import { gradientColors } from '../../../styles/colors';
import { ProgressStepIndicatorContainerStyled as Container, ProgressStepIndicatorContentGridContainerStyled as GridContainer, ProgressStepIndicatorStepMarkerCellStyled as StepMarkerCell, ProgressStepIndicatorStepLineStyled as StepLine, ProgressStepIndicatorStepTextCellStyled as StepTextCell, ProgressStepIndicatorTitleTextStyled as TitleText, ProgressStepIndicatorDescriptionTextStyled as DescriptionText, ProgressStepIndicatorSpacerLineCellStyled as SpacerLineCell, } from '../../../styles';
import { StepStatus } from '../../../types';
const getStepRowElement = (stepNumber, status, step, maxSteps) => {
    const gridRowNumber = stepNumber * 2 - 1;
    return (_jsxs(_Fragment, { children: [_jsxs(StepMarkerCell, { style: { gridRow: gridRowNumber }, children: [_jsx(StepMarker, { stepNumber: stepNumber, status: status }), stepNumber < maxSteps && (_jsx(StepLine, { style: {
                            ...(status === StepStatus.COMPLETED && {
                                backgroundColor: elementColors.purple,
                            }),
                        } }))] }), _jsxs(StepTextCell, { style: { gridRow: gridRowNumber }, children: [step.title && (_jsx(TitleText, { style: {
                            ...(status === StepStatus.CURRENT && {
                                background: gradientColors['100'],
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }),
                            ...(status === StepStatus.COMPLETED && { color: fontColors.dark }),
                            ...(status === StepStatus.NEXT && { color: fontColors.lightGrey }),
                        }, children: step.title })), step.description && (_jsx(DescriptionText, { style: { ...((status === StepStatus.CURRENT || status === StepStatus.COMPLETED) && { color: fontColors.dark }) }, children: step.description }))] }), stepNumber < maxSteps && (_jsx(SpacerLineCell, { style: { gridRow: gridRowNumber + 1 }, children: _jsx(StepLine, { style: {
                        ...(status === StepStatus.COMPLETED && {
                            backgroundColor: elementColors.purple,
                        }),
                    } }) }))] }));
};
const getStepStatus = (stepNumber, activeStep) => {
    if (stepNumber < activeStep) {
        return StepStatus.COMPLETED;
    }
    else if (stepNumber > activeStep) {
        return StepStatus.NEXT;
    }
    else if (stepNumber === activeStep) {
        return StepStatus.CURRENT;
    }
    throw new Error('Unable to determine step status');
};
const getStepElements = (activeStep, steps) => {
    return steps.map((step, index) => {
        const stepNumber = index + 1;
        const stepStatus = getStepStatus(stepNumber, activeStep);
        return getStepRowElement(stepNumber, stepStatus, step, steps.length);
    });
};
const ProgressStepIndicator = (props) => {
    const { activeStep, steps = [], style } = props;
    return (_jsx(Container, { style: style, children: _jsx(GridContainer, { children: getStepElements(activeStep, steps) }) }));
};
export default ProgressStepIndicator;
